import { Component, OnInit } from '@angular/core';
import {style, animate, transition, state, trigger} from '@angular/animations';

import { ActivatedRoute } from '@angular/router';

import { BsModalService } from 'ngx-bootstrap/modal';

import { CacheService } from '../../global/ng2-cache/services/cache.service';
import { SessionService } from '../../services/session2.service';
import { ErrorService } from '../../services/error.service';
import { WorkflowService } from '../../services/workflow.service';
import { ActonService } from '../../services/acton.service';
import { GlobalMessageService } from '../../services/global-message.service';
import { AlertDialogComponent } from '../../global/alert-dialog/alert-dialog.component';
import { DriftService } from '../../services/drift.service';

import { Constants, EmailType, Language, ContactQuality, SiftrockField } from '../../global/constants';

@Component({
  selector: 'app-wf-acton-detail',
  templateUrl: './wf-acton-detail.component.html',
  animations: [
    trigger('draftState',
      [
        state('inactive', style({
          opacity: 0,
          transform: 'scale(.9)'
        })),
        state('active', style({
          opacity: 1,
          transform: 'scale(1)'
        })),
        transition('inactive => active', animate('300ms ease-in'))
      ]
    )
  ]
})
export class WFActonDetailComponent implements OnInit {

  loadingPage = true;
  id: string = '';
  partner: string = 'acton';
  activeStep: string = 'type';
  help: boolean = false;
  workflow: any = {};
  wfType: string = '';
  draftSaved: string = '';
  draftState: string = 'inactive';

    // type management
    selectedTypes: any = {};
    selectedLanguages: any[] = [];
    languageList: any[] = [];
    languageDDSettings: any = {
      text: 'Select language(s)',
      unSelectAllText: 'Remove all but English'
    };

  // list state/management
  lists: any[] = [];
  currentList: string;

  // field/state management
  fields: any[] = [];
  currentSRField: SiftrockField;
  destFields: any[] = [];
  currentDestField: any;
  currentStaticField: any;
  staticValue: string = '';

  // filter/state management
  currentIncludeFilterField: SiftrockField;
  includeFilterValue: string = '';
  currentExcludeFilterField: SiftrockField;
  excludeFilterValue: string = '';

  quality = {
    high: true,
    med: true,
    low: false
  };

  refreshState = {
    lists: 0,
    fields: 0,
  };

  requiredFields = [
    'First Name',
    'Last Name',
    'Business Phone',
    'Drift Email Reply Type',
    'Drift Email URL'
  ];

  fieldExclusions = [
    '_contact_id_',
    'Email',
    'E-mail Address'
  ];

  constructor(private route: ActivatedRoute,
              private cacheService: CacheService,
              private sessionService: SessionService,
              private errorService: ErrorService,
              private modalService: BsModalService,
              private workflowService: WorkflowService,
              private actonService: ActonService,
              private globalMessageService: GlobalMessageService,
              private driftService: DriftService,
              private constants: Constants) { }

  ngOnInit() {
    this.constants.emailTypes.forEach((t) => {
      this.selectedTypes[t.typeName] = false;
    });

    this.constants.languages.forEach(l => {
      if (l.supported) {
        this.languageList.push({
          id: l.name,
          itemName: l.display
        });
      }
    });

    this.languageList.push({
      id: 'other',
      itemName: 'Other'
    });

    if (!this.cacheService.get('session')) {
      this.sessionService.getSession(true).subscribe(
        (session: any) => {
          this.initView();
        }
      )
    }
    else {
      this.initView();
    }
  }


  languageAdd(item) {
    if (this.selectedLanguages.length == this.languageList.length) {
      // 'all' languages
      this.workflow.trigger.language = ['all'];
    }
    else {
      this.workflow.trigger.language = this.selectedLanguages.map(l => { return l.id });
    }
    var update = { 'trigger.language': this.workflow.trigger.language };
    this.saveWorkflow(update);
    this.driftService.track('edited-workflow', { type: `${this.wfType} Contacts`, field: 'Language' });
  }

  languageRemove(item) {
    if (this.selectedLanguages.length > 0) {
      this.workflow.trigger.language = this.selectedLanguages.map(l => { return l.id });
    }
    else {
      // force at least one language
      this.selectedLanguages = [{ id: 'en', itemName: 'English'}];
      this.workflow.trigger.language = ['en'];
    }
    var update = { 'trigger.language': this.workflow.trigger.language };
    this.saveWorkflow(update);
    this.driftService.track('edited-workflow', { type: `${this.wfType} Contacts`, field: 'Language' });
  }

  languageAddAll(items) {
    this.workflow.trigger.language = ['all'];
    var update = { 'trigger.language': ['all'] };
    this.saveWorkflow(update);
    this.driftService.track('edited-workflow', { type: `${this.wfType} Contacts`, field: 'Language' });
  }

  languageRemoveAll(items) {
    // force at least one language
    this.selectedLanguages = [{ id: 'en', itemName: 'English'}];
    this.workflow.trigger.language = ['en'];
    var update = { 'trigger.language': this.workflow.trigger.language };
    this.saveWorkflow(update);
    this.driftService.track('edited-workflow', { type: `${this.wfType} Contacts`, field: 'Language' });
  }

  typeChange() {
    this.workflow.trigger.type = [];
    for (var key in this.selectedTypes) {
      if (this.selectedTypes[key]) {
        this.workflow.trigger.type.push(key);
      }
    }

    var update = { 'trigger.type': this.workflow.trigger.type };
    this.saveWorkflow(update);
    this.driftService.track('edited-workflow', { type: `${this.wfType} Contacts`, field: 'Email type' });
  }

  changeQuality() {
    if (!this.quality.low && !this.quality.med && !this.quality.high) {
      this.workflow.trigger.confidence = [1];
      this.modalService.show(AlertDialogComponent, Object.assign({}, {
        initialState: {
          message: `At least one contact quality must be chosen. We've automatically selected "High".`,
          confirmBtn: 'Ok'
        }
      }));

      setTimeout(() => {
        this.quality.high = true;
      }, 50);
    }
    else {
      this.workflow.trigger.confidence = [];
      if (this.quality.high) {
        this.workflow.trigger.confidence.push(1);
      }
      if (this.quality.med) {
        this.workflow.trigger.confidence.push(2);
      }
      if (this.quality.low) {
        this.workflow.trigger.confidence.push(3);
      }
    }

    this.saveWorkflow({'trigger.confidence': this.workflow.trigger.confidence});
    this.driftService.track('edited-workflow', { type: `${this.wfType} Contacts`, field: 'Contact quality' });
  }

  changeTriggerRecipient() {
    this.saveWorkflow({'trigger.recipient': this.workflow.trigger.recipient});
    this.driftService.track('edited-workflow', { type: `${this.wfType} Contacts`, field: 'Create recipient' });
  }

  refreshLists() {
    this.actonService.clearListCache();
    this.getLists();
  }

  changeList(list) {
    this.currentList = list.value;
    this.actonService.clearFieldCache();
    this.getFields(this.currentList, (err) => {
      if (err) {

      }
      else {
        var missingFields = [];
        var oneEmailField = false; // Act-On has different names for the email address field so we need to check them all
        this.requiredFields.forEach((rf) => {
          var found = false;
          this.fields.forEach((f) => {
            if (rf == f.name) {
              found = true;
            }

            if (f.name.toLowerCase() == 'e-mail address' || f.name.toLowerCase() == 'email') {
              oneEmailField = true;
            }
          });

          if (!found) {
            missingFields.push(rf);
          }
        });

        if (!oneEmailField) {
          missingFields.push('E-mail Address');
        }

        if (missingFields.length > 0) {
          this.currentList = '';
          var message = 'One or more required fields is missing in the list you selected. Please add these fields to your list or select a different list: ';
          missingFields.forEach((mf) => {
            message += mf + ', ';
          });
          message = message.substring(0, message.length-2);
          this.modalService.show(AlertDialogComponent, Object.assign({}, {
            initialState: {
              message: message,
              confirmBtn: 'Close'
            }
          }));
        }
        else {
          // all is good
          this.workflow.action.list = {
            id: list.value,
            name: list.label
          };
          this.workflow.action.fields = [];
          this.workflow.action.static_fields = [];
          this.saveWorkflow({ 'action.list': this.workflow.action.list, 'action.fields': [], 'action.static_fields': [] });
          this.driftService.track('edited-workflow', { type: `${this.wfType} Contacts`, field: 'List' });
        }
      }
    });
  }

  clearList() {
    this.currentList = '';
    this.workflow.action.list = {};
    this.workflow.action.fields = [];
    this.workflow.action.static_fields = [];
    this.saveWorkflow({ 'action.list': this.workflow.action.list, 'action.fields': [], 'action.static_fields': [] });
    this.driftService.track('edited-workflow', { type: `${this.wfType} Contacts`, field: 'List' });
  }

  refreshFields() {
    this.actonService.clearFieldCache();
    this.getFields(this.currentList, (err) => {
    });
  }

  srFieldChange(field) {
    this.destFields = [];
    this.fields.forEach((f) => {
      if (f.type == field.type && !f.used) {
        this.destFields.push(f);
      }
    });
  }

  addSRFieldMapping() {
    this.workflow.action.fields.push({
      id: this.currentDestField.id,
      description: this.currentDestField.description,
      name: this.currentDestField.name,
      siftrock_description: this.currentSRField.display,
      value: this.currentSRField.fieldName
    });

    this.workflow.action.fields.sort(function (a, b) {
      if (a.description < b.description) {
        return -1;
      }
      else {
        return 1;
      }
    });

    this.fields.forEach((f) => {
      if (f.id == this.currentDestField.id) {
        f.used = true;
      }
    });

    this.constants.siftrockFields.forEach((f) => {
      if (f.fieldName == this.currentSRField.fieldName) {
        f.used = true;
      }
    });

    this.currentSRField = null;
    this.currentDestField = null;
    this.saveWorkflow( {'action.fields': this.workflow.action.fields});
    this.driftService.track('edited-workflow', { type: `${this.wfType} Contacts`, field: 'Drift Email field map' });
  }

  removeSRFieldMapping(field) {
    this.currentSRField = null;
    this.currentDestField = null;
    this.workflow.action.fields.splice(this.workflow.action.fields.indexOf(field), 1);
    this.saveWorkflow( {'action.fields': this.workflow.action.fields});
    this.driftService.track('edited-workflow', { type: `${this.wfType} Contacts`, field: 'Drift Email field map' });
  }

  addStaticFieldMapping() {
    this.workflow.action.static_fields.push({
      id: this.currentStaticField.id,
      description: this.currentStaticField.description,
      name: this.currentStaticField.name,
      value: this.staticValue
    });

    this.fields.forEach((f) => {
      if (f.id == this.currentStaticField.id) {
        f.used = true;
      }
    });

    this.currentStaticField = null;
    this.staticValue = '';
    this.saveWorkflow( {'action.static_fields': this.workflow.action.static_fields} );
    this.driftService.track('edited-workflow', { type: `${this.wfType} Contacts`, field: 'Static field map' });
  }

  removeStaticFieldMapping(field) {
    this.currentStaticField = null;
    this.staticValue = '';
    this.workflow.action.static_fields.splice(this.workflow.action.static_fields.indexOf(field), 1);
    this.saveWorkflow( {'action.static_fields': this.workflow.action.static_fields} );
    this.driftService.track('edited-workflow', { type: `${this.wfType} Contacts`, field: 'Static field map' });
  }

  addIncludeFilter() {
    this.includeFilterValue = this.includeFilterValue.toLowerCase();
    var found = false;
    this.workflow.action.include_filters.forEach((f) => {
      if (f.field == this.currentIncludeFilterField.fieldName) {
        found = true;
        f.values.push(this.includeFilterValue);
      }
    });

    if (!found) {
      this.workflow.action.include_filters.push({
        field: this.currentIncludeFilterField.fieldName,
        display: this.currentIncludeFilterField.display,
        values: [this.includeFilterValue]
      });
    }

    this.workflow.action.include_filters.sort((a,b) => {
      if (a.display < b.display) {
        return -1;
      }
      else {
        return 1;
      }
    });

    this.includeFilterValue = '';
    this.saveWorkflow( {'action.include_filters': this.workflow.action.include_filters} );
    this.driftService.track('edited-workflow', { type: `${this.wfType} Contacts`, field: 'Include filter' });
  }

  removeIncludeFilter(filter, value) {
    filter.values.splice(filter.values.indexOf(value), 1);
    if (filter.values.length == 0) {
      this.workflow.action.include_filters.splice(this.workflow.action.include_filters.indexOf(filter), 1);
    }
    this.saveWorkflow( {'action.include_filters': this.workflow.action.include_filters} );
    this.driftService.track('edited-workflow', { type: `${this.wfType} Contacts`, field: 'Include filter' });
  }

  addExcludeFilter() {
    this.excludeFilterValue = this.excludeFilterValue.toLowerCase();
    var found = false;
    this.workflow.action.exclude_filters.forEach((f) => {
      if (f.field == this.currentExcludeFilterField.fieldName) {
        found = true;
        f.values.push(this.excludeFilterValue);
      }
    });

    if (!found) {
      this.workflow.action.exclude_filters.push({
        field: this.currentExcludeFilterField.fieldName,
        display: this.currentExcludeFilterField.display,
        values: [this.excludeFilterValue]
      });
    }

    this.workflow.action.exclude_filters.sort((a,b) => {
      if (a.display < b.display) {
        return -1;
      }
      else {
        return 1;
      }
    });

    this.excludeFilterValue = '';
    this.saveWorkflow( {'action.exclude_filters': this.workflow.action.exclude_filters} );
    this.driftService.track('edited-workflow', { type: `${this.wfType} Contacts`, field: 'Exclude filter' });
  }

  removeExcludeFilter(filter, value) {
    filter.values.splice(filter.values.indexOf(value), 1);
    if (filter.values.length == 0) {
      this.workflow.action.exclude_filters.splice(this.workflow.action.exclude_filters.indexOf(filter), 1);
    }
    this.saveWorkflow( {'action.exclude_filters': this.workflow.action.exclude_filters} );
    this.driftService.track('edited-workflow', { type: `${this.wfType} Contacts`, field: 'Exclude filter' });
  }

  private initView() {
    this.route.params.subscribe(
      params => {
        this.id = params['id'];
        if (this.id == 'new') {
          // check query string for type
          this.route.queryParams.subscribe(
            qs => {
              this.initNew(qs['type'] || 'contacts');
              this.wfType = this.workflow.trigger.data == 'contacts' ? 'Create' : 'Update';
              this.getLists();
              this.loadingPage = false;
            }
          );
        }
        else {
          this.workflowService.getWorkflow(this.id).subscribe(
            (result: any) => {
              this.workflow = result;
              this.workflow.trigger.type.forEach((t) => {
                this.selectedTypes[t] = true;
              });
              this.quality = {
                low: false,
                med: false,
                high: false
              };
              if (this.workflow.trigger.confidence.indexOf(1) >= 0) {
                this.quality.high = true;
              }
              if (this.workflow.trigger.confidence.indexOf(2) >= 0) {
                this.quality.med = true;
              }
              if (this.workflow.trigger.confidence.indexOf(3) >= 0) {
                this.quality.low = true;
              }

              this.wfType = this.workflow.trigger.data == 'contacts' ? 'Create' : 'Update';

              this.workflow.trigger.language.forEach(lang => {
                this.languageList.forEach(listlang => {
                  if (listlang.id == lang || lang == 'all') {
                    this.selectedLanguages.push(listlang);
                  }
                });
              });

              this.getLists();
              if (this.workflow.action.list.id) {
                this.currentList = this.workflow.action.list.id;
                this.getFields(this.currentList, (err) => {

                });
              }
              this.loadingPage = false;
            },
            error => {
              this.globalMessageService.error();
              this.errorService.log(error, 'wf-acton-detail.component', 'ngOnInit.100');
            }
          )
        }
      }
    )
  }

  private getLists() {
    this.refreshState.lists = 1;
    this.lists = [];
    this.actonService.getLists().subscribe(
      (result: any) => {
        result.forEach((l) => {
          this.lists.push({
            label: l.name,
            value: l.id.toString()
          });

          if (this.workflow.action.list.id && this.workflow.action.list.id==l.id) {
            this.currentList = l.id.toString();
          }
        });
        this.refreshState.lists = 0;
        if (this.lists.length == 0) {
          this.refreshState.lists = 2;
        }
      },
      error => {
        this.refreshState.lists = 2;
      }
    );
  }

  private getFields(listId: string, callback) {
    this.refreshState.fields = 1;
    this.fields = [];
    this.actonService.getFields(listId).subscribe(
      (result: any) => {
        if (!result) {
          this.refreshState.fields = 2;
        }
        else {
          this.fields = result;
          this.refreshState.fields = 0;
          this.fields.forEach((f) => {
            f.used = false;

            this.requiredFields.forEach((rf) => {
              if (rf == f.name) {
                f.used = true;
              }
            });

            this.fieldExclusions.forEach((fe) => {
              if (fe == f.name) {
                f.used = true;
              }
            });

            this.workflow.action.fields.forEach((af) => {
              if (af.id == f.id) {
                f.used = true;
              }
            });

            this.workflow.action.static_fields.forEach((sf) => {
              if (sf.id == f.id) {
                f.used = true;
              }
            });
          });

          this.fields.sort((a, b) => {
            if (a.description < b.description) {
              return -1;
            }
            else {
              return 1;
            }
          });
        }
        callback(null);
      },
      error => {
        this.refreshState.fields = 2;
        callback('Problem');
      }
    )
  }

  private saveWorkflow(update: any) {
    this.draftState = 'inactive';
    if (this.workflow._id == 'new') {
      // special case for first-time save
      this.workflowService.saveNew(this.workflow).subscribe(
        (result: any) => {
          this.workflow = result;
          this.draftSaved = new Date().toLocaleTimeString();
          this.draftState = 'active';
          this.driftService.track('added-workflow', { type: `${this.wfType} Contacts` });
        },
        error => {
          this.globalMessageService.error();
          this.errorService.log(error, 'wf-acton-detail.component', 'saveWorkflow.100');
        }
      )
    }
    else {
      this.workflowService.savePartial(this.workflow._id, update).subscribe(
        (result: any) => {
          this.draftSaved = new Date().toLocaleTimeString();
          this.draftState = 'active';
        },
        error => {
          this.globalMessageService.error();
          this.errorService.log(error, 'wf-acton-detail.component', 'saveWorkflow.200');
        }
      )
    }
  }

  private initNew(dataType: string) {
    let defaultTypes: string[] = [];
    if (dataType=='contacts') {
      defaultTypes = [
        'changed',
        'general',
        'human',
        'left',
        'unknown',
        'vacation'
      ];

      defaultTypes.forEach((t) => {
        this.selectedTypes[t] = true;
      });
      // Default is English only for new contacts
      this.selectedLanguages = [{
        id: 'en',
        itemName: 'English'
      }];
    }
    else {
      // Default is all languages
      this.selectedLanguages = JSON.parse(JSON.stringify(this.languageList));
    }

    this.workflow = {
      _id: 'new',
      type: 'integration',
      partner: this.partner,
      trigger: {
          type: defaultTypes,
          data: dataType,
          confidence: [1,2],
          language: ['all'],
          recipient: false
      },
      action: {
          list: {},
          fields: [],
          recipient_fields: [],
          static_fields: [],
          include_filters: [],
          exclude_filters: []
      },
      enabled: false,
      deleted: false
    };

    this.updateSession(dataType);
  }

  private updateSession(dataType) {
    // when a user creates a new workflow, re-set their session to whatever type they are creating
    // so when navigating back to workflows the created workflow will be on the screen
    this.sessionService.getSession().subscribe(
      (result: any) => {
        if (result) {
          result.workflow_filters.type = 'all';
          result.workflow_filters.wf_type = dataType;
          result.workflow_filters.last_changed = new Date();
          this.sessionService.saveSession(result).subscribe(
            (result: any) => {
              // Nothing
            },
            err => {
              this.errorService.log(err, 'wf-acton-detail.component', 'saveSession');
            }
          )
        }
      },
      error => {

      }
    )
  }

}



// WEBPACK FOOTER //
// ./client/app/config/workflows/wf-acton-detail.component.ts